/**
 * ADA Fix Issue 20: PhotoSwipe Gallery Dialog Label
 * 
 * Ensures the PhotoSwipe gallery dialog has an accessible label
 * 
 * WCAG 2.2 Criteria:
 * - 4.1.2 Name, Role, Value (Level A)
 * - Dialogs must have accessible names
 * 
 * Issue: PhotoSwipe gallery dialog has role="dialog" but lacks aria-label
 * Solution: Add aria-label="Product Gallery" to the PhotoSwipe dialog container
 */

(function() {
  'use strict';
  
  console.log('🔧 ADA Fix: Ensuring PhotoSwipe gallery has accessible label...');
  
  const PHOTOSWIPE_SELECTOR = '.pswp[role="dialog"]';
  const ARIA_LABEL = 'Product Gallery';
  
  /**
   * Add aria-label to PhotoSwipe dialog
   */
  function fixPhotoSwipeLabel() {
    const pswpElements = document.querySelectorAll(PHOTOSWIPE_SELECTOR);
    
    pswpElements.forEach(pswp => {
      if (!pswp.hasAttribute('aria-label')) {
        pswp.setAttribute('aria-label', ARIA_LABEL);
        console.log('✅ ADA Fix: Added aria-label to PhotoSwipe gallery');
      }
    });
  }
  
  /**
   * Observe DOM for PhotoSwipe initialization
   */
  function setupMutationObserver() {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) { // Element node
            // Check if the added node is PhotoSwipe
            if (node.classList && node.classList.contains('pswp')) {
              fixPhotoSwipeLabel();
            }
            
            // Check if PhotoSwipe was added inside this node
            if (node.querySelector) {
              const pswp = node.querySelector(PHOTOSWIPE_SELECTOR);
              if (pswp) {
                fixPhotoSwipeLabel();
              }
            }
          }
        });
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    console.log('👀 ADA Observer: Monitoring for PhotoSwipe galleries...');
  }
  
  /**
   * Initialize on DOM ready
   */
  function initialize() {
    // Fix any existing PhotoSwipe instances
    fixPhotoSwipeLabel();
    
    // Setup observer for dynamic galleries
    setupMutationObserver();
    
    // Also check periodically in case PhotoSwipe loads slowly
    setTimeout(fixPhotoSwipeLabel, 1000);
    setTimeout(fixPhotoSwipeLabel, 2000);
    setTimeout(fixPhotoSwipeLabel, 3000);
  }
  
  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
  
  // Expose for manual testing
  window.adaPhotoSwipeLabel = {
    fix: fixPhotoSwipeLabel,
    label: ARIA_LABEL
  };
  
  console.log('🔧 ADA PhotoSwipe Label fix loaded. Functions available in window.adaPhotoSwipeLabel');
})();
